import React from 'react';
import { api_domain } from "../config"

async function getImage(url: string) {
  const img = document.createElement('img');
  img.src = url;
  await new Promise(resolve => img.onload = resolve);
  return img;
}

interface ScreenshotProps {
  ad: any,
  blur: string,
  url: string
}

interface ScreenshotState {
  width: number,
  height: number,
  classname: string,
  onclick: any
}

export class CroppedScreenshot extends React.Component<ScreenshotProps, ScreenshotState> {
  private canvasRef: React.RefObject<HTMLCanvasElement>;

  constructor(props: ScreenshotProps) {
    super(props);
    this.canvasRef = React.createRef();
    this.state = { width: 0, height: 0, classname: ""};
  }

  async componentDidMount() {
    this.renderScreenshot();
  }

  async componentDidUpdate(prevProps: ScreenshotProps) {
    if (this.props.ad.adId !== prevProps.ad.adId || this.props.blur !== prevProps.blur) {
      this.renderScreenshot();
    }
  }


  async renderScreenshot() {
    const ad = this.props.ad
    const img = await getImage(`${api_domain}/i/${ad.path_to_image}`);
    const x = ad.img_box_x && ad.img_box_x > 0 ? ad.img_box_x : 0
    const y = ad.img_box_y && ad.img_box_y > 0 ? ad.img_box_y : 0
    const width = ad.img_box_width ? Math.min(ad.img_box_width, img.width) : img.width
    const height = ad.img_box_height ? Math.min(ad.img_box_height, img.height) : img.height
    const classname = "figure-img rounded screenshot classify-screenshot" + (this.props.blur === "true" ? " blurred" : "")
    this.setState({ height: height, width: width, classname: classname, onclick: ""});

    const canvas = this.canvasRef.current;
    if (!canvas) {
      console.log('Canvas element doesn\'t exist')
      return;
    }

    canvas.addEventListener('click',
      function(e){this.classList.toggle('blurred');});

    const ctx = canvas.getContext('2d');
    if (!ctx) {
      console.log('Failed to get canvas context');
      return;
    }

    ctx.clearRect(0, 0, width, height);

    ctx.drawImage(img,
        x, y, width, height,
        0, 0, width, height);

    // if (x > 0) {
    //     ctx.drawImage(img,
    //       0, 0, x, height,
    //       0, 0, x, height);
    //   }
    //   if (x + width < img.width) {
    //     ctx.drawImage(img,
    //       x + width, 0, x - width, height,
    //       x + width, 0, x - width, height);
    //   }
    //   if (y > 0) {
    //     ctx.drawImage(img,
    //       x, 0, width, y,
    //       x, 0, width, y);
    //   }
    //   if (y + height < img.height) {
    //     ctx.drawImage(img,
    //       x, y + height, width, height - y,
    //       x, y + height, width, height - y);
    //   }
    
  }


  render() {
    return (
       <canvas className={this.state.classname} ref={this.canvasRef} id={this.props.url}
           width={this.state.width}
           height={this.state.height}>
       </canvas>
    );
  }
}
